import { useCallback } from "react"


export const useTableData = () => {

  const getControlData = useCallback((data, fieldName) => {
    return data[fieldName];
  }, [])


  const loadTableData = useCallback((schema, data) => {

    let tableData = []
    for (let i in schema.properties) {
      let tableRow = {
        "name": i,
        "type": schema.properties[i].type,
        "analyte": schema.properties[i].prop_analyte,
        "kv": schema.properties[i].prop_kv,
        "measure": schema.properties[i].prop_measure,
        "section": schema.properties[i].prop_section,
        "maximum": schema.properties[i].maximum
      }

      //console.log(i)
      //console.log(schema.properties[i])
      tableData.push(tableRow)
    }
    return tableData;
  }, [getControlData])


  const generateSchemafromTable = useCallback((schema, tableData) => {
    const newSchema = JSON.parse(JSON.stringify(schema));
    delete newSchema.properties;
    newSchema.properties = {};

    console.log('updating schema! New blanc schema:', newSchema)
    console.log('current table data:', tableData)
    //alert(3)

    for (let i in tableData) {
      //console.log(i)
      let props = {
        "type": tableData[i].type,
        "prop_analyte": tableData[i].analyte,
        "prop_kv": tableData[i].kv,
        "prop_measure": tableData[i].measure,
        "prop_section": tableData[i].section,
      }

      if (tableData[i].maximum) {
        if (tableData[i].type === 'integer') {
          props.maximum = parseInt(tableData[i].maximum)
        }
        if (tableData[i].type === 'number') {
          props.maximum = Number(tableData[i].maximum)
        }
      }


      newSchema.properties[tableData[i].name] = props
    }

    console.log('schema after update:', newSchema)
    //alert(8)

    return newSchema;
  }, [])


  return { 
    loadTableData,
    generateSchemafromTable 
  }

}